import { combineEpics } from 'redux-observable';
import { makePayment$ } from 'modules/payment/epics/makePayment$';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default combineEpics(makePayment$);
